import { gcm } from '@noble/ciphers/aes';

//------------ - -----------------------------------------------------------------------------------
//CRN_20251203 - ⚠️ These methods are for obfuscation only not security i.e. hide IDs in the URL ⚠️
//------------ - -----------------------------------------------------------------------------------

//#region CRN_20260128 - Removing CBC & PKCS#7
/*
export function EncryptAesClientSide(plaintext: string): string {
  const iv       =CryptoJS.enc.Utf8.parse('7061737323313233');
  const key      =CryptoJS.enc.Utf8.parse('7061737323313233');
  const encrypted=CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plaintext), key, {
    iv     : iv,
    keySize: 128/8,
    mode   : CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return encrypted.toString();
}

export function EncryptAesClientSideForWeb(plaintext: string): string {
  return EncryptAesClientSide(plaintext)
         .replaceAll("%",  "%25") //CRN_20250315 - Must do the % first!
         .replaceAll("+",  "%2B")
         .replaceAll("!",  "%21")
         .replaceAll("\"", "%22")
         .replaceAll("#",  "%23")
         .replaceAll("$",  "%24")
         .replaceAll("&",  "%26")
         .replaceAll("'",  "%27")
         .replaceAll("(",  "%28")
         .replaceAll(")",  "%29")
         .replaceAll("*",  "%2A")
         .replaceAll("+",  "%2B")
         .replaceAll(",",  "%2C")
         .replaceAll("-",  "%2D")
         .replaceAll(".",  "%2E")
         .replaceAll("/",  "%2F")
         .replaceAll(":",  "%3A")
         .replaceAll(";",  "%3B")
         .replaceAll("<",  "%3C")
         .replaceAll("=",  "%3D")
         .replaceAll(">",  "%3E")
         .replaceAll("?",  "%3F")
         .replaceAll("@",  "%40")
         .replaceAll("[",  "%5B")
         .replaceAll("\\", "%5C")
         .replaceAll("]",  "%5D")
         .replaceAll("^",  "%5E")
         .replaceAll("_",  "%5F")
         .replaceAll("`",  "%60")
         .replaceAll("{",  "%7B")
         .replaceAll("`",  "%7C")
         .replaceAll("}",  "%7D")
         .replaceAll("~",  "%7E");
}

export function DecryptAesClientSide(ciphered: null | string | undefined): null | string | undefined {
  if (!ciphered)
    return ciphered;
  
  const iv       =CryptoJS.enc.Utf8.parse('7061737323313233');
  const key      =CryptoJS.enc.Utf8.parse('7061737323313233');
  const decrypted=CryptoJS.AES.decrypt(ciphered, key, {
    iv     : iv,
    keySize: 128/8,
    mode   : CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}
*/
//#endregion

//#region CRN_20260128 - AES-GCM Authenticated Encryption

const KEY_BYTES=new TextEncoder().encode('7061737323313233');

function toBase64Url(bytes: Uint8Array): string {
  let bin='';

  for (let i=0; i<bytes.length; i++)
    bin += String.fromCharCode(bytes[i]);

  return btoa(bin).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
}

function fromBase64Url(b64url: string): Uint8Array {
  let b64=b64url.replaceAll('-', '+').replaceAll('_', '/');

  while (b64.length % 4)
    b64 += '=';

  const bin=atob(b64);
  const out=new Uint8Array(bin.length);

  for (let i=0; i<bin.length; i++)
    out[i]=bin.charCodeAt(i);

  return out;
}

export function EncryptAesClientSide(plaintext: string): string {
  const nonce=new Uint8Array(12);

  crypto.getRandomValues(nonce);

  const _plaintext=new TextEncoder().encode(plaintext);
  const aesGcm    =gcm(KEY_BYTES, nonce);
  const ctAndTag  =aesGcm.encrypt(_plaintext);

  return `${toBase64Url(nonce)}.${toBase64Url(ctAndTag)}`;
}

export function EncryptAesClientSideForWeb(plaintext: string): string {
  return EncryptAesClientSide(plaintext);
}

export function DecryptAesClientSide(ciphered: null | string | undefined): null | string | undefined {
  if (!ciphered)
    return ciphered;

  const parts=ciphered.split('.');

  if (parts.length !== 2)
    throw new Error('DecryptAesClientSide() Invalid AES-GCM payload');

  const nonce   =fromBase64Url(parts[0]);
  const ctAndTag=fromBase64Url(parts[1]);

  const aesGcm   =gcm(KEY_BYTES, nonce);
  const plaintext=aesGcm.decrypt(ctAndTag);

  return new TextDecoder().decode(plaintext);
}

//#endregion
